import React from "react";

interface ILayoutContext {
	toggleSidebar: () => void;
	openSidebar: () => void;
	closeSidebar: () => void;
}

export const LayoutContext = React.createContext<Partial<ILayoutContext>>({});
